import {
  apiRequest,
  masterWorkUnit,
  masterWorkUnitEchelonTwo,
  masterEmployeeStatus,
  downloadDRH,
  masterEchelon,
  masterEmployeeCategories,
  exportExcel,
} from "../../../../../services/adapters/kepegawaian/homeService";

class IndexRepository {
  fetchWorkUnit = async (query) => {
    return await apiRequest(
      "get",
      masterWorkUnit,
      {
        params: query,
      },
      true
    );
  };

  fetchWorkUnitEchelonTwo = async (query) => {
    return await apiRequest(
      "get",
      masterWorkUnitEchelonTwo,
      {
        params: query,
      },
      true
    );
  };

  fetchEmployeeStatus = async (query) => {
    return await apiRequest(
      "get",
      masterEmployeeStatus,
      {
        params: query,
      },
      true
    );
  };

  fetchDownloadDRH = async (query) => {
    return await apiRequest(
      "get",
      downloadDRH,
      {
        params: query,
      },
      true
    );
  };

  fetchEchelon = async (query) => {
    return await apiRequest(
      "get",
      masterEchelon,
      {
        params: query,
      },
      true
    );
  };

  fetchEmployeeCategories = async (query) => {
    return await apiRequest(
      "get",
      masterEmployeeCategories,
      {
        params: query,
      },
      true
    );
  };

  fetchExportExcel = async (query) => {
    return await apiRequest(
      "get",
      exportExcel,
      {
        params: query,
      },
      true
    );
  };
}

export default IndexRepository;
